// src/features/hmi-simulator/constants/config.ts
import { HMIConfig } from '../types';

export const DEFAULT_CONFIG: HMIConfig = {
  hotelName: "Loading...",
  primaryColor: "#007bff",
  availableLanguages: ["EN"],
  defaultLanguage: "EN",
  logoBase64: "",
  texts: {
    EN: {
      loading: "Loading configuration...",
      provisioning: "Provisioning device...",
      need_locker_title: "Need a locker?",
      have_code_title: "Have a code?",
      email_instructions: "Enter your email to receive your access code instantly",
      code_instructions: "Enter your access code to open your locker",
      email_placeholder: "your.email@example.com",
      code_placeholder: "Enter your code",
      get_code_button: "Get locker code",
      submit_button: "Submit",
      your_locker: "YOUR LOCKER",
      button_cancel: "Cancel",
      button_open: "Open",
      staff_login: "Staff Login",
      password_placeholder: "Enter password",
      login_button: "Login"
    }
  }
};

export const HEARTBEAT_INTERVAL = 30000;
export const HEARTBEAT_INITIAL_DELAY = 1000;
